import { Model } from './abstract-model';

class Item extends Model {
  // TODO: Eliminar clase vacÃ­a
}

export default Item;
